export const ResolutionTypes = Object.freeze({
	COUNT: 'count',
	BINARY: 'binary',
	METRIC: 'metric',
	STREAK: 'streak',
});

export const ResolutionTypeOptions = Object.values(ResolutionTypes);

export default ResolutionTypes;
